import * as moment from 'moment';
import { IPosition } from '@nkr/models/index';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { InternalDirectAction, internalDirectActionList } from '../../../models';

interface IProps {
    data: IPosition,
    action: InternalDirectAction,
    onAction: (data: IPosition, action: InternalDirectAction) => void
}

const PositionRow = (props: IProps) => {
    const currentAction = internalDirectActionList.find(x => x.action == props.action);
    const title = currentAction != null ? currentAction.title : 'Actions';

    return (
        <tr>
            <td>
                {props.data.chainId}/{props.data.clusterNumber}/{props.data.positionNumber}
            </td>
            <td>
                <a href={`center/${props.data.donor.centerId}/donor/${props.data.donor.id}/profile/donor-data`} target='_blank'>{props.data.donor.alias}</a>
            </td>
            <td>{props.data.donor.center.alias}</td>
            <td>{props.data.recipient.alias}</td>
            <td>{props.data.recipient.center.alias}</td>
            <td>
                {moment(props.data.donor.logistics.kidneyPickupDateTime, 'MM/DD/YYYY').format('MM/DD/YYYY')}
            </td>
            <td>
                <DropdownButton bsSize='sm' title={title} id={'dd-btn-' + props.data.donor.id} onSelect={(e) => props.onAction(props.data, e)}>
                    {internalDirectActionList.map(item =>
                        <MenuItem eventKey={item.action}>{item.title}</MenuItem>
                    )}
                </DropdownButton>
            </td>
        </tr>
    );
}

export default PositionRow;